<template>
  <div id="main-content">
    <a-row :gutter="16">
      <a-col :xxl="12" :xl="24" style="margin-bottom: 10px;">
        <div id="cash-map"
             style="background: #ffffff;height: 350px;width: 100%;padding: 10px;border-radius: 10px;"></div>
      </a-col>
      <a-col :xxl="6" :xl="12" :md="12" style="margin-bottom: 10px;">
        <div id="cash-channel-map"
             style="background: #ffffff;height: 350px;width: 100%;padding: 10px;border-radius: 10px;"></div>
      </a-col>
      <a-col :xxl="6" :xl="12" :md="12" style="margin-bottom: 10px;">
        <div id="cash-country-map"
             style="background: #ffffff;height: 350px;width: 100%;padding: 10px;border-radius: 10px;"></div>
      </a-col>
    </a-row>
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-radio-group button-style="solid" v-model="dimension" @change="init_data">
          <a-radio-button value="date">
            日期
          </a-radio-button>
          <a-radio-button value="channel">
            渠道
          </a-radio-button>
          <a-radio-button value="country">
            国家
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item>
        <a-select v-model="channel" style="width: 200px" allowClear
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择展示渠道"
                  @change="init_data">
          <a-select-option v-for="channelItem in $store.state.RevenueChannel"
                           :label="channelItem.name"
                           :value="channelItem.value"
                           :key="channelItem.value">
            {{ channelItem.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select v-model="country" style="width: 200px" allowClear mode="multiple" :maxTagCount="1"
                  optionFilterProp="label" placeholder="请选择国家" @change="init_data()">
          <a-select-option :key="countryItem.value" :value="countryItem.value"
                           :label="countryItem.name"
                           v-for="countryItem in $store.state.Country">
            {{ countryItem.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="primary" html-type="submit">导出</a-button>
      </a-form-item>
      <a-form-item style="float: right">
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="changeDate()"/>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" :data-source="tableData"
             :rowKey="item=>item.dimension" :loading="tableLoad"
             style="background: #ffffff;"
             bordered :pagination="false">
      <!--<template slot="footer"  slot-scope="currentPageData">-->
      <!--  <a-pagination-->
      <!--    v-model="page"-->
      <!--    style="text-align: right"-->
      <!--    show-size-changer-->
      <!--    :total="count"-->
      <!--    :page-size="page_size"-->
      <!--    @change="changePage"-->
      <!--    @showSizeChange="changePage"-->
      <!--  />-->
      <!--</template>-->
    </a-table>
  </div>
</template>

<script>
import {GetCashCountry, GetCashChannel, GetCashChannelDate, GetCashAnalysis} from "../../../api/v1/cash_api";

export default {
  name: "Index",
  data() {
    return {
      cashMap: undefined,
      cashChannelMap: undefined,
      cashCountryMap: undefined,
      tableData: [],
      page: 1,
      page_size: 10,
      count: 100,
      date: ['', ''],
      channel: [],
      country: [],
      dimension: 'date',
      tableLoad: false,
    }
  },
  mounted() {
    this.cashMap = this.$echarts.init(document.getElementById('cash-map'))
    this.cashChannelMap = this.$echarts.init(document.getElementById('cash-channel-map'))
    this.cashCountryMap = this.$echarts.init(document.getElementById('cash-country-map'))
    this.init_map()
    this.init_data()
  },
  watch: {
    getAppId: {
      handler(newName, oldName) {
        this.changeDate()
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    getAppId() {
      return this.$store.getters.getAppId
    },
    getTableColumns() {
      let _table_columns = [
        {title: '维度指标', dataIndex: 'dimension',},
        {title: '收益', dataIndex: 'revenue', scopedSlots: {customRender: 'revenue'},},
        {title: '展示', dataIndex: 'impression', scopedSlots: {customRender: 'impression'}},
        {title: 'ECPM', dataIndex: 'ecpm', scopedSlots: {customRender: 'ecpm'}},
      ]
      return _table_columns
    }
  },
  methods: {
    init_map() {
      GetCashChannelDate({
        app_id: this.$store.getters.getAppId,
        start: this.date[0],
        end: this.date[1]
      }).then(resp => {
        if (resp.code === 200) {
          let _option_series = []
          Object.keys(resp.data.list).forEach(_list_key => {
            let _option_series_data = []
            resp.data.fields.forEach(_date => {
              _option_series_data.push(
                resp.data.list[_list_key][_date] ? resp.data.list[_list_key][_date] : 0
              )
            })
            _option_series.push({
              name: _list_key,
              type: 'bar',
              stack: 'total',
              label: {show: true},
              emphasis: {focus: 'series'},
              data: _option_series_data
            })
          })
          let _option = {
            title: {text: '每日渠道收益'},
            tooltip: {trigger: 'axis', axisPointer: {type: 'shadow'}},
          legend: { right: 0,left: 150,type: 'scroll', },
            grid: {left: '3%', right: '4%', bottom: '3%', containLabel: true},
            xAxis: {type: 'value'},
            yAxis: {type: 'category', data: resp.data.fields},
            series: _option_series
          }
          this.cashMap.setOption(_option, true)
        }
      })
      GetCashChannel({
        app_id: this.$store.getters.getAppId,
        start: this.date[0],
        end: this.date[1]
      }).then(resp => {
        if (resp.code === 200) {
          let _channel_data = []
          resp.data.list.forEach(item => {
            _channel_data.push({
              name: item.channel,
              value: item.revenue
            })
          })
          let _channel = {
            title: {text: '渠道收益占比',},
            tooltip: {trigger: 'item', formatter: "{b} : {c} ({d}%)"},
          legend: { right: 0,left: 150,type: 'scroll', },
            series: [{
              name: 'Access From', type: 'pie', radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {borderRadius: 10, borderColor: '#fff', borderWidth: 2},
              label: {show: false, position: 'center'},
              emphasis: {label: {show: true, fontSize: '30', fontWeight: 'bold'}},
              labelLine: {show: false},
              data: _channel_data
            }
            ]
          }
          this.cashChannelMap.setOption(_channel, true)
        }
      })
      GetCashCountry({
        app_id: this.$store.getters.getAppId,
        start: this.date[0],
        end: this.date[1]
      }).then(resp => {
        if (resp.code === 200) {
          let _channel_data = []
          resp.data.list.forEach(item => {
            _channel_data.push({
              name: item.country,
              value: item.revenue
            })
          })
          let _country = {
            title: {text: '国家收益占比',},
            tooltip: {trigger: 'item', formatter: "{b} : {c} ({d}%)"},
          legend: { right: 0,left: 150,type: 'scroll', },
            series: [{
              name: 'Access From', type: 'pie', radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {borderRadius: 10, borderColor: '#fff', borderWidth: 2},
              label: {show: false, position: 'center'},
              emphasis: {label: {show: true, fontSize: '30', fontWeight: 'bold'}},
              labelLine: {show: false},
              data: _channel_data
            }
            ]
          }
          this.cashCountryMap.setOption(_country, true)
        }
      })
    },
    init_data() {
      if (this.tableLoad) return
      this.tableLoad = true
      GetCashAnalysis({
        dimension: this.dimension,
        country: this.country,
        channel: this.channel,
        app_id: this.$store.getters.getAppId,
        start: this.date[0],
        end: this.date[1],
      }).then(resp => {
        this.tableLoad = false
        if (resp.code === 200) {
          this.tableData = resp.data.list
          this.date = resp.data.date
        }
      })
    },
    changeDate() {
      this.init_map()
      this.init_data()
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Revenue/Analysis/Index.vue